import React, { Component } from "react";
import DesktopHeader from "../components/DesktopHeader";
import MobileHeader from "../components/MobileHeader";
import "./Contact.css";

class Contact extends Component {
  render() {

    return (
      <div
        className="contact-container"
        style={{
          height: "100vh",
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          fontFamily: "Raleway",
          overflow: "hidden",
          justifyContent: "center",
          alignItems: "flex-start"
        }}
      >
        {window.innerWidth > 768 ? <DesktopHeader /> : <MobileHeader />}
        <div
          className="row"
          style={
            window.innerWidth > 1200
              ? {
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  fontFamily: "Raleway",
                  color: "#5C626C",
                  paddingTop: "10%"
                }
              : {
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  fontFamily: "Raleway",
                  color: "#5C626C",
                  paddingTop: "5%"
                }
          }
        >
          <div
            style={{
              alignItems: "center",
              width: "100%",
              fontFamily: "Raleway",
              color: "#5C626C",
              textAlign: "center"
            }}
          >
            <h1>Contact Us</h1>
          </div>
        </div>
        <div
          className="row"
          style={
            window.innerWidth > 1200
              ? {
                  justifyContent: "center",
                  width: "40%",
                  fontFamily: "Raleway",
                  color: "#5C626C",
                  marginTop: "-15%"
                }
              : {
                  justifyContent: "center",
                  width: "90%",
                  fontFamily: "Raleway",
                  color: "#5C626C",
                  marginTop: "-15%"
                }
          }
        >
          <div className="col" style={{ flexWrap: "wrap" }}>
            <form
              action="https://formsubmit.co/9a0cc722ca9696c004bbdc706c587cb3"
              method="POST"
            >
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                style={{
                  padding: "2%",
                  width: "100%",
                  height: "20px",
                  borderRadius: "4px",
                  border: "1px solid #0c5087"
                }}
              />
              <input
                type="text"
                name="name"
                placeholder="Message"
                style={{
                  padding: "2%",
                  marginTop: "2%",
                  width: "100%",
                  height: "100px",
                  borderRadius: "4px",
                  border: "1px solid #0c5087"
                }}
              />
              <input type="hidden" name="_next" value="https://kindertogether.com/sendconfirmation" />
              <input type="text" name="_honey" style={{display:"none"}}/>
              <input type="hidden" name="_captcha" value="false"/>
              <input
                type="submit"
                value="Send"
                style={{
                  alignSelf: "center",
                  marginTop: "2%",
                  width: "104%",
                  background: "#0c5087",
                  borderRadius: "4px",
                  color: "white",
                  border: 0,
                  cursor: "pointer",
                  padding: "4% 4% 4% 4%"
                }}
              />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
